/** Align with wai/subscriptions/ddq_entitlement_codes.py */
export const GP_DDQ_REASON_CODES = {
  QUOTA_EXCEEDED: 'ddq_own_fund_quota_exceeded',
  DDQ_OPTION_REQUIRED: 'ddq_option_required',
  GP_IM_UNAVAILABLE: 'gp_im_unavailable',
} as const;

export type GpDdqReasonCode = (typeof GP_DDQ_REASON_CODES)[keyof typeof GP_DDQ_REASON_CODES];

export interface GpOwnFundDdqCanStartResponse {
  allowed: boolean;
  denial_reason: string | null;
  period: { month: number; year: number };
  limit: number;
  used: number;
  remaining: number;
}

/** Parse 403 JSON from subscriptions DDQ routes */
export function getSubscriptionDenialReason(body: unknown): string | undefined {
  if (!body || typeof body !== 'object') {
    return undefined;
  }
  const o = body as Record<string, unknown>;
  return (
    (typeof o.reason_code === 'string' && o.reason_code) ||
    (typeof o.reasonCode === 'string' && o.reasonCode) ||
    undefined
  );
}

export function shouldShowDdOptionUpsell(reason?: string): boolean {
  return reason === GP_DDQ_REASON_CODES.DDQ_OPTION_REQUIRED;
}

export function shouldBlockGpImAction(reason?: string): boolean {
  return reason === GP_DDQ_REASON_CODES.GP_IM_UNAVAILABLE;
}

export function isGpOwnFundQuotaExceededReason(reason?: string | null): boolean {
  return reason === GP_DDQ_REASON_CODES.QUOTA_EXCEEDED;
}
